import React from 'react';
import TextArea from 'src/modules/shared/components/atoms/inputs/text-area';
import { BaseFieldProps } from 'src/modules/shared/types/json-schema.type';

/**
 * Props for EmptySchemaInput component
 */
export interface EmptySchemaInputProps extends BaseFieldProps {
  placeholder?: string;
}

/**
 * Empty schema input component for JSON Schema form
 * Handles fields with empty schemas as a JSON text area
 */
export const EmptySchemaInput: React.FC<EmptySchemaInputProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  nullable = false,
  // TODO: check when implementing i18n
  placeholder = 'Ingresa un valor o un texto con formato JSON',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    try {
      const parsedValue = JSON.parse(e.target.value);
      onChange(parsedValue);
    } catch (_error) {
      const inputValue = e.target.value;
      const isEmpty = inputValue === '';

      if (nullable && isEmpty) {
        onChange(null);
      }

      onChange(inputValue || '');
    }
  };

  const valueString =
    typeof value === 'object'
      ? JSON.stringify(value, null, 2)
      : (value as string) || '';

  return (
    <TextArea
      id={id}
      value={valueString}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      rows={4}
      resize="vertical"
    />
  );
};
